import { ISendFirstMessageV3ResponseSchema } from '../../../repositories/chats/entities/chat/SendFirstMessageV3ResponseSchema';
import { EStatus } from '../../../repositories/chats/entities/synchronization/SyncChatSchema';
import { DEFAULT_ERROR_MESSAGE } from '../constants';
import { EFirstMessageResponseStatus, TFirstMessageResponse } from '../types';

export const map200Response = ({ chat, modalWarning }: ISendFirstMessageV3ResponseSchema): TFirstMessageResponse => {
  if (chat && chat.chatId) {
    return {
      status: EFirstMessageResponseStatus.Success,
      data: chat,
    };
  }

  if (chat && chat.status === EStatus.Blocked) {
    return {
      status: EFirstMessageResponseStatus.Blocked,
    };
  }

  if (modalWarning) {
    return {
      status: EFirstMessageResponseStatus.ForbiddenText,
      data: modalWarning,
    };
  }

  return { status: EFirstMessageResponseStatus.UnknownError, data: { message: DEFAULT_ERROR_MESSAGE } };
};
